'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

var handleToggleClick = function handleToggleClick(_ref) {
  var self = _ref.currentTarget;

  var selector = self.dataset.toggle || self;
  var action = self.dataset.toggleAction;
  var clear = self.dataset.toggleClear;
  var animated = self.dataset.toggleAnimated === 'true';
  var lockScroll = self.dataset.lockScroll;
  var unlockScroll = self.dataset.unlockScroll;
  var className = self.dataset.activeClass || _Dom2.default.isActiveClassName;

  if (lockScroll) {
    // disableBodyScroll($(lockScroll)[0]);
    $('html').addClass('full-height');
  }

  if (unlockScroll) {
    // enableBodyScroll($(unlockScroll)[0]);
    $('html').removeClass('full-height');
  }

  PubSub.publish(_Constants2.default.toggle, { selector: selector, className: className, action: action, clear: clear, animated: animated });

  return false;
};

var bindActions = exports.bindActions = function bindActions() {
  $(_Dom2.default.toggle).on('click', handleToggleClick);
};